import { Select } from '../ui/Select.jsx';
import { Input } from '../ui/Input.jsx';

const toOpts = (arr) => (arr || []).map((v) => ({ value: v, label: v }));

/**
 * Parameter panel for the playground. Adapts to the active mode: text shows
 * chat models + sampling + streaming, voice shows realtime models + voice.
 */
export function ModelControls({ mode, options, personalityOptions, state, onChange, disabled }) {
  const isVoice = mode === 'voice';
  const modelOpts = isVoice ? toOpts(options.realtimeModels) : toOpts(options.chatModels);
  const agentOpts = [{ value: '', label: 'Agente predefinito' }, ...((options.agents || []).map((a) => ({ value: a.id, label: a.label })))];

  return (
    <div className="flex flex-col gap-3">
      <Select
        label="Personalità"
        options={personalityOptions}
        value={state.personalityId}
        disabled={disabled}
        onChange={(e) => onChange('personalityId', e.target.value)}
      />
      <Select
        label={isVoice ? 'Modello vocale' : 'Modello'}
        options={modelOpts}
        value={state.model}
        disabled={disabled}
        onChange={(e) => onChange('model', e.target.value)}
      />
      {isVoice ? (
        <>
          <Select
            label="Voce"
            options={toOpts(options.voices)}
            value={state.voice}
            disabled={disabled}
            onChange={(e) => onChange('voice', e.target.value)}
          />
          <Select
            label="Agente"
            options={agentOpts}
            value={state.agentId}
            disabled={disabled}
            onChange={(e) => onChange('agentId', e.target.value)}
          />
        </>
      ) : (
        <>
          <Input
            label="Temperatura"
            type="number"
            step="0.1"
            min="0"
            max="2"
            value={state.temperature}
            onChange={(e) => onChange('temperature', e.target.value)}
          />
          <Input
            label="Token max"
            type="number"
            min="1"
            max="8192"
            value={state.maxTokens}
            placeholder="default Setting"
            onChange={(e) => onChange('maxTokens', e.target.value)}
          />
          <label className="flex items-center justify-between rounded-md border border-border bg-surface px-3 py-2 text-sm">
            <span className="text-ink">Risposte in streaming</span>
            <input
              type="checkbox"
              checked={state.streaming}
              onChange={(e) => onChange('streaming', e.target.checked)}
              className="h-4 w-4 accent-ink"
            />
          </label>
        </>
      )}
    </div>
  );
}
